<div [style.transform]="getTransform()">
  <graphic [src]="src"></graphic>
  <i class="material-icons">fullscreen</i>
</div>

